/* eslint-disable no-multi-spaces */
export interface EventLog {
  id: string;
  date: number;
  logType: string;
  triggeredBy: EventTrigger;
  recipients: string[];
  description: string;
  userId?: string;
  userName?: string;
  category: LogCategory;
  deepLink: string | null;
}

export enum LogType {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info'
}

export enum EventTrigger {
  SYSTEM = 'system',
  USER = 'user'
}

// prettier-ignore
export enum LogCategory {
  AGREEMENTS      = 'agreements',           // dialog/agreement/{id} or residents
  APP_INV         = 'invitation',           // dialog/resident/{id}
  APP_INV_SUB     = 'invitation_sub',       // dialog/subcontractor/{id}
  BOOKING         = 'booking',              // booking/users
  CONCIERGE       = 'concierge',            // dialog/concierge/{id}
  DEFECT          = 'defect',               // dialog/defects/{id}
  EMAILING        = 'emailing',             // report/mailing
  EMAIL_NTFS      = 'email_notifications',  // -----
  ESTATE_MODULES  = 'estate_modules',      // ------
  ESTATE_DOCS     = 'estate_documents',     // estate/files
  FILE_UPLOAD     = 'file_upload',          // ------
  METERS          = 'meters',               // reckonings/meters
  NEWS            = 'news',                 // news/active/{id}
  PAYMENTS        = 'payments',             // dialog/{unit}/{id}
  PROTOCOL        = 'protocol',             // dialog/{unit}/{id}
  RECKONINGS      = 'reckonings',           // reckonings/charges
  RESIDENTS       = 'residents',            // dialog/resident/{id}
  SAP             = 'sap_import',           // ------
  MIESZCZANIN     = 'mieszczanin_import',   // ------
  USER            = 'user',                 // dialog/resident/{id}
  USER_ACCESS     = 'user_access',          // dialog/resident/{id}
  USER_DOCS       = 'user_docs',            // dialog/resident/{id}
  REVIEWS         = 'reviews',              // estate/reviews/{id}
  RESOLUTIONS     = 'resolutions',          // resolutions/active/{id}
  CONTACT         = 'contact',              // estate/contacts
  SMS_ALERT       = 'sms_alert',            // reports/sms or dialog/sms/{id}
  RENOVATION      = 'renovation',           // estate/renovations/{id}
  WELES           = 'weles',                // -------
  WEBCON          = 'webcon',               // dialog/resident/{id}
  BLUEBOLT        = 'bluebolt',             // bluebolt/resident-access
}
